<script setup lang="ts">
import AutocompleteField from '@/components/Selector/AutocompleteField.vue'
import type { SelectorObject } from '@/types/components/SelectorObject'
import { computed } from 'vue'
import EditableFieldWrapper from './EditableFieldWrapper.vue'

const props = defineProps<{
    label?: string
    tooltip?: string
    value?: string
    boldLabel?: boolean
    isInEditMode?: boolean
    required?: boolean
    options?: SelectorObject[]
}>()
const emit = defineEmits<{ (e: 'change', value: string | undefined): void }>()

const modelValue = computed({
    get: () => props.value,
    set: value => emit('change', value)
})
</script>

<template>
    <EditableFieldWrapper
        :label="label"
        :tooltip="tooltip"
        :value="value"
        :boldLabel="boldLabel"
        :isInEditMode="isInEditMode">
        <AutocompleteField
            :options="options"
            :modelValue="modelValue"
            @change="(value: string | undefined) => (modelValue = value)"
            :placeholder="label"
            :required="required"
            v-bind="$attrs" />
    </EditableFieldWrapper>
</template>
